<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button class="mr-16" (click)="regresar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h2 class="m-0">{{'PERFIL_USUARIO.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span></span>
            </div>
            <!-- / CONTENT TOOLBAR -->
            <div class="w100 p-20" fxFlex>
              <mat-sidenav-container class="h100">
                <mat-sidenav [mode]="'side'" [(opened)]="menuAbierto" class="w25">
                  <!-- <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
                    <h2>Opciones</h2>
                    <button mat-icon-button (click)="menuAbierto = !menuAbierto" class="mr-20">
                      <mat-icon class="s-20">close</mat-icon>
                    </button>
                  </div> -->
                  <mat-list>
                    <!-- <mat-list-item class="hta" [ngClass]="{'opcSel':enlaceMenu == 'configuracion'}">
                      <mat-icon mat-list-icon>settings</mat-icon>
                      <button mat-button (click)="enlaceMenu = 'configuracion'; enviaInfoUsuario();">
                        {{'PERFIL_USUARIO.TITULO.ENLACES.configuracion'}}
                      </button>
                    </mat-list-item>
                    <mat-divider [inset]="true"></mat-divider> -->

                    <ng-container *ngFor="let enlace of enlaces;">
                      <mat-list-item class="hta" [ngClass]="{'opcSel':enlaceMenu == enlace.nombre}">
                        <mat-icon mat-list-icon>{{enlace.icono}}</mat-icon>
                        <button mat-button (click)="enlaceMenu = enlace.nombre; enviaInfoUsuario();">
                          {{'PERFIL_USUARIO.ENLACES.' + enlace.nombre | translate}}
                        </button>
                      </mat-list-item>
                      <mat-divider [inset]="true"></mat-divider>
                    </ng-container>

                  </mat-list>
                </mat-sidenav>
                <mat-sidenav-content class="white">
                  <ng-container *ngIf="enlaceMenu">
                    <h1 class="m-20">{{'PERFIL_USUARIO.ENLACES.' + enlaceMenu | translate}}</h1>
                    <mat-divider class="ml-20"></mat-divider>
                  </ng-container>
                  <ng-container [ngSwitch]="enlaceMenu">
                    <configuracion [datosUsuario]="enviaDatosUsu.asObservable()" *ngSwitchCase="'configuracion'"></configuracion>
                  </ng-container>
                </mat-sidenav-content>
              </mat-sidenav-container>
            </div>
        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
